import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ICorrelationsState, correlationsAdapter, correlationsKey } from './correlations.state';

export const selectCorrelationsState = createFeatureSelector<ICorrelationsState>(correlationsKey);

const { selectAll, selectEntities, selectIds, selectTotal } = correlationsAdapter.getSelectors(selectCorrelationsState);

export const selectAllCorrelations = selectAll;
export const selectCorrelationEntities = selectEntities;
export const selectCorrelationIds = selectIds;
export const selectCorrelationsTotal = selectTotal;

export const selectCorrelationsLoading = createSelector(selectCorrelationsState, state => state.loading);
export const selectCorrelationsLoaded = createSelector(selectCorrelationsState, state => state.loaded);
export const selectCorrelationsError = createSelector(selectCorrelationsState, state => state.error);
export const selectPrevCorrelationsRequest = createSelector(selectCorrelationsState, state => state.request);

export const selectCorrelationsById = (correlationId: string) =>
  createSelector(selectCorrelationEntities, correlationsMap => correlationsMap[correlationId]);
